/** 权限配置 */

export class Auth {
    /** 1.首页 */
    static HOME = 'HOME'

    /** 2.工作台 */
    static WORKSPACE = {
        ROOT: 'WORKSPACE',                          // 2.工作台

        /** 2.1项目管理 */
        PROJECT: {
            ROOT: 'PROJECT:MANAGEMENT',              // 2.1项目管理
            WORK: 'WORKSPACE:PROJECT:WORK',          // 2.1.1工作
            TASK: 'WORKSPACE:PROJECT:TASK',          // 2.1.2任务
            PROJECT: 'WORKSPACE:PROJECT:PROJECT',    // 2.1.3项目
        },

        /** 2.2AI 大模型 */
        AI_MODEL: 'AI:MODEL',

        /** 2.3培训管理 */
        TRAINING: {
            ROOT: 'TRAINING:MANAGEMENT',             // 2.3培训管理
            LEARN: 'WORKSPACE:TRAINING:LEARN',       // 2.3.1学习
            LIBRARY: 'WORKSPACE:TRAINING:LIBRARY',   // 2.3.2课程库
            MY: 'WORKSPACE:TRAINING:MY',             // 2.3.3我的
        },

        /** 2.4审批管理 */
        APPROVAL: {
            ROOT: 'APPROVAL:MANAGEMENT',             // 2.4审批管理
            INITIATE: 'WORKSPACE:APPROVAL:INITIATE', // 2.4.1发起审批
            MY: 'WORKSPACE:APPROVAL:MY',             // 2.4.2我的审批
            SUBMITTED: 'WORKSPACE:APPROVAL:SUBMITTED', // 2.4.3已提交的
            CONTRACT_STATS: 'WORKSPACE:APPROVAL:CONTRACT_STATS', // 2.4.4合同统计
        },

        /** 2.5汇报 */
        REPORT: {
            ROOT: 'REPORT:MANAGEMENT',               // 2.5汇报
            MY: 'WORKSPACE:REPORT:MY',               // 2.5.1我的汇报
            STATISTICS: 'WORKSPACE:REPORT:STATISTICS', // 2.5.2汇报统计
        },

        /** 2.6合同管理 */
        CONTRACT: {
            ROOT: 'CONTRACT:MANAGEMENT',             // 2.6合同管理
            MY: 'WORKSPACE:CONTRACT:MY',             // 2.6.1我的合同
            DRAFT: 'WORKSPACE:CONTRACT:DRAFT',       // 2.6.2合同草稿
            STATS: 'WORKSPACE:CONTRACT:STATS',       // 2.6.3合同统计
        },

        /** 2.7档案借阅 */
        ARCHIVE: {
            ROOT: 'ARCHIVE:BORROW',                  // 2.7档案借阅
            BORROW: 'WORKSPACE:ARCHIVE:BORROW',      // 2.7.1档案借阅
            MY: 'WORKSPACE:ARCHIVE:MY',              // 2.7.2我的借阅
            APPLY: 'WORKSPACE:ARCHIVE:APPLY',              // 2.7.2我的申请
        },

        /** 2.8客户管理 */
        CUSTOMER: {
            ROOT: 'CUSTOMER:MANAGEMENT',                // 2.8客户管理
            PUNTER: 'WORKSPACE:CUSTOMER:PUNTER',        // 2.8.1客户
            FOLLOW: 'WORKSPACE:CUSTOMER:FOLLOW',        // 2.8.2跟进记录
        },

        /** 2.9库存管理 */
        INVENTORY: {
            ROOT: 'INVENTORY:MANAGEMENT',              // 2.9库存管理
            INBOUND: 'WORKSPACE:INVENTORY:INBOUND',    // 2.9.1入库
            OUTBOUND: 'WORKSPACE:INVENTORY:OUTBOUND',  // 2.9.2出库
            TRANSFER: 'WORKSPACE:INVENTORY:TRANSFER',  // 2.9.3库存调拨
            INBOUNDLIST: 'WORKSPACE:INVENTORY:INBOUNDLIST',  // 2.9.4入库单
            OUTBOUNDLIST: 'WORKSPACE:INVENTORY:OUTBOUNDLIST',  // 2.9.5出库单
            TRANSFERLIST: 'WORKSPACE:INVENTORY:TRANSFERLIST',  // 2.9.6库存调拨单
        },
        WORK_ORDER: {
            ROOT: 'work-order:query',
            CREATE: 'work-order:create',
            UPDATE: 'work-order:update',
            DELETE: 'work-order:delete',
            DISPATCH: 'work-order:dispatch',
            EXECUTE: 'work-order:execute',
        },
    }

    /** 3.我的 */
    static MY = {
        ROOT: 'MY',                                   // 3.我的
        SOCIAL: 'MY:SOCIAL',                          // 3.1社交信息
        DEVELOP: 'MY:DEVELOP',                        // 3.2开发调试
        LOGOUT: 'MY:LOGOUT',                          // 3.3退出    
    }
}
